export type FaqItem = {
  question: string;
  answer: string;
};

export const faqItems: FaqItem[] = [
  {
    question: "Pourquoi 7500€ alors qu'un freelance facture moins cher ?",
    answer:
      "Un freelance vous vend du temps. Nous vous vendons un résultat : stratégie, design, développement, SEO et suivi jusqu'à vos premiers résultats sont inclus. Pas de mauvaise surprise, pas de facture qui grimpe une fois le site \"presque fini\".",
  },
  {
    question: "Le site est livré en 2 semaines, mais est-ce vraiment du sur-mesure ?",
    answer:
      "Oui. Ce délai vient de notre méthode rodée (audit → maquette validée → développement), pas d'un template pré-fait. Chaque étape est validée avec vous avant de passer à la suivante.",
  },
  {
    question: "Que se passe-t-il si mon site n'apporte pas de résultats après le lancement ?",
    answer:
      "On reste à vos côtés. On mesure vos vraies données et on ajuste la stratégie et le SEO tant que vous n'avez pas obtenu vos premiers résultats concrets.",
  },
  {
    question: "Le SEO est-il vraiment inclus, ou c'est encore une option cachée ?",
    answer:
      "Inclus dès le départ, dans les 7500€. Ce n'est pas une ligne ajoutée après coup sur le devis.",
  },
  {
    question: "Et si je ne suis pas satisfait du design proposé ?",
    answer:
      "La maquette est validée avec vous AVANT le développement. Rien n'est codé tant que vous n'avez pas donné votre accord sur le design.",
  },
  {
    question: "Combien de temps dure votre accompagnement après la mise en ligne ?",
    answer:
      "Jusqu'à vos premiers résultats. Pas de date limite arbitraire : on ajuste tant que ça n'a pas décollé.",
  },
];
